import { Box, Typography } from '@mui/material';
import React from 'react';
import { useI18nContext } from '@procore/core-react';
import SimilarBusinessesCard from './SimilarBusinessesCard';
import { Business } from '../../types/business';
import routes from '../../helpers/routes';
import { useStyles } from './SimilarBusinesses.styles';
import AnalyticsWrappedComponent from '../Analytics/AnalyticsWrappedComponent';

interface SimilarBusinessesProps {
  similarBusinesses: Business[];
}

const SimilarBusinesses = ({ similarBusinesses }: SimilarBusinessesProps) => {
  const I18n = useI18nContext();
  const classes = useStyles();
  return (
    <Box my={4} className={classes.container}>
      <Box mx={4} className={classes.headingContainer}>
        <Typography className={classes.heading} variant="h3">
          {I18n.t('components.similar_businesses.also')}
        </Typography>
      </Box>
      <Box className={classes.scrollContainer}>
        <Box className={classes.cardsContainer}>
          {similarBusinesses.slice(0, 4).map((b) => (
            <AnalyticsWrappedComponent
              key={`similar-business-${b.primarySlug}`}
              componentType="a"
              eventText="Clicked Business"
              eventLabel="Search Results - Similar Businesses"
              additionalEventProperties={{
                Name: b.name,
                ID: b.id,
                City: b.primaryAddress?.city,
                State: b.primaryAddress?.province,
                Services: b.providedServices?.map((ps) => ps.name),
                Slug: b.primarySlug,
              }}
              data-track-click={`Similar Business, Navigation, ${b.name}`}
              href={routes.businesses(b.primarySlug)}
              rel="noreferrer"
              target="_blank"
              style={{
                textDecoration: 'none',
                color: 'inherit',
                cursor: 'pointer',
                height: '100%',
                width: '100%',
                overflow: 'hidden',
              }}
            >
              <SimilarBusinessesCard business={b} />
            </AnalyticsWrappedComponent>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SimilarBusinesses;
